export default __webpack_public_path__ + "static/media/432-Series-Stainless-Regulators.4ef3917f.jpg";